import Tobii from "tobii";
import Blazy from "blazy";
import getAverageColor from "./averageColor";

const html = document.querySelector("html");
const body = document.querySelector("body");
body.classList.add("js");

if (document.querySelectorAll(".lightbox").length > 0) {
	new Tobii();
}

new Blazy({
	selector: ".lazy",
	successClass: "loaded",
	success: function(element) {
		console.log(element.parentElement);
		// get the average color of header images
		if (element.parentElement.classList.contains("page-header-image")) {
			let avg = getAverageColor(element);
			console.log(avg);
			element.parentElement.style.backgroundColor = `rgb(${avg.r},${avg.g},${avg.b})`;
		}
	}
});

/** Toggle the mobile menu
* @returns {void}
*/
function toggleMobileMenu() {
	html.classList.toggle("menu-opened");
}

document.querySelector(".menu-toggler").addEventListener(
	"click",
	function(e) {
		e.preventDefault();
		toggleMobileMenu();
	},
	false
);

var link = document.getElementsByClassName('linker');

for (var i = 0; i < link.length; i++) {
	link[i].addEventListener('click', function(){
		if(html.classList.contains('menu-opened')) {
			html.classList.remove('menu-opened');
		}
	});
}

// document.querySelector(".search-toggler").addEventListener(
// 	"click",
// 	function(e) {
// 		e.preventDefault();
//
// 		let mobileSearchEl = document.getElementById("mobileSearch");
//
// 		if (html.classList.contains("menu-opened")) {
// 			mobileSearchEl.focus();
// 		} else {
// 			html.classList.add("menu-opened");
// 			mobileSearchEl.focus();
// 		}
//
// 		return false;
// 	},
// 	false
// );

/** calculate the height of the mobile bar
 * @returns {void} nothin
 */
function calcMobileBarHeight() {
	console.log("calculate mobile bar height");
	let mobileBar = document.querySelector(".mobile-bar");
	let mobileMenu = document.querySelector(".mobile-menu");
	body.style.paddingTop = mobileBar.offsetHeight + "px";
	mobileMenu.style.paddingTop = mobileBar.offsetHeight + "px";
}

window.addEventListener("resize", calcMobileBarHeight);
window.addEventListener("load", calcMobileBarHeight);

var readmoreFirst = document.getElementsByClassName('read-more')[0];
var readmoreSecond = document.getElementsByClassName('read-more')[1];
var readmore = document.getElementsByClassName('read-more');
var readless = document.getElementsByClassName('read-less')[0];
var readlessMobile = document.getElementsByClassName('read-less-mobile')[0];
var steprow = document.getElementsByClassName('step-row');
var stepimg = document.getElementsByClassName('step-img');
var stepMobileImg = document.getElementsByClassName('step-mobile-img');

	readmoreFirst.addEventListener("click", function() {
		for (var i = 0; i < steprow.length; i++) {
			steprow[i].classList.add('d-flex');
		}
		for (var i = 0; i < readmore.length; i++) {
			readmore[i].classList.remove('d-inline-flex');
			readmore[i].classList.add('d-none');
		}
		for (var i = 0; i < stepMobileImg.length; i++) {
			stepMobileImg[i].classList.add('d-block');
		}

		readlessMobile.classList.remove('d-none');
		readlessMobile.classList.add('d-inline-flex');
	});

	readmoreSecond.addEventListener("click", function() {
		for (var i = 0; i < steprow.length; i++) {
			steprow[i].classList.add('d-flex');
		}
		for (var i = 0; i < readmore.length; i++) {
			readmore[i].classList.remove('d-md-inline-flex');
			readmore[i].classList.add('d-none');
		}
		for (var i = 0; i < stepimg.length; i++) {
			stepimg[i].classList.add('d-block');
		}

		readless.classList.remove('d-none');
		readless.classList.add('d-md-inline-flex');
	});

	readless.addEventListener("click", function() {
		for (var i = 0; i < steprow.length; i++) {
			steprow[i].classList.remove('d-flex');
		}

		readless.classList.remove('d-md-inline-flex');
		readless.classList.add('d-none');
		readmoreSecond.classList.add('d-md-inline-flex');
		readmoreSecond.classList.remove('d-none');

		for (var i = 0; i < stepimg.length; i++) {
			stepimg[i].classList.remove('d-block');
		}
	});

	readlessMobile.addEventListener("click", function() {
		for (var i = 0; i < steprow.length; i++) {
			steprow[i].classList.remove('d-flex');
		}

		readlessMobile.classList.remove('d-inline-flex');
		readlessMobile.classList.add('d-none');
		readmoreFirst.classList.add('d-inline-flex');
		readmoreFirst.classList.remove('d-none');

		for (var i = 0; i < stepMobileImg.length; i++) {
			stepMobileImg[i].classList.remove('d-block');
		}
	});

$(document).ready(function(){
	$(".teamSlider").slick({
	  dots: false,
	  infinite: true,
	  speed: 300,
	  arrows: true,
	  mobileFirst:true,
	  // autoplay:true,
   	  // mobileFirst:true,//add this one
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  centerMode: false,
	  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
	});
});
